import React from 'react'
import Button from 'components/shared/Button'

const AllStatesSearchResultCard = (props) => {

    const { searchResult, viewResult, applicantId } = props

    return (
        <div className='searchResultCard'>
            <div className='searchResultCardContent'>
                <div className='searchResultCardHeader'>
                    <h6>Search Results</h6>
                </div>
                <div className='searchResultCardBody'>
                    <div className='row'>
                        <div className='col-md-8'>
                            <div className='resultDetails'>
                                <div className='resultItem'>
                                    <span className='resultLabel'>Business Name:</span>
                                    <span className='resultValue'>{searchResult.businessName || 'N/A'}</span>
                                </div>
                                <div className='resultItem'>
                                    <span className='resultLabel'>State:</span>
                                    <span className='resultValue'>{searchResult.state || 'N/A'}</span>
                                </div>
                                <div className='resultItem'>
                                    <span className='resultLabel'>Status:</span>
                                    <span className='resultValue'>{searchResult.status || 'N/A'}</span>
                                </div>
                                {searchResult.entityId && (
                                    <div className='resultItem'>
                                        <span className='resultLabel'>Entity ID:</span>
                                        <span className='resultValue'>{searchResult.entityId}</span>
                                    </div>
                                )}
                            </div>
                        </div>
                        <div className='col-md-4 text-right'>
                            <Button 
                                onClick={() => viewResult(searchResult)}
                                variant="outlined"
                            >
                                View Details
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AllStatesSearchResultCard